import { createSlice } from "@reduxjs/toolkit";
import { updateClaim } from "./claimCommunityApi";

const updateClaimSlice = createSlice({
  name: "updateClaim",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(updateClaim.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClaim.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateClaim.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default updateClaimSlice.reducer;
